module.exports = __webpack_public_path__ + "static/media/26.4d10269d.png";